const formatDuration = (duration: number) => {
    const minutes = Math.floor(duration / 60);
    const seconds = Math.floor(duration % 60);
    const secondsString = seconds < 10 ? `0${seconds}` : `${seconds}`;
    return `${minutes}:${secondsString}`;
}

export default formatDuration;
